import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const article = {
  checkDirtyArticle: lazyModuleMethod(
    () => import('./checkDirtyArticle'),
    'default'
  ),
  fetchArticle: lazyModuleMethod(() => import('./fetchArticle'), 'default'),
  fetchArticles: lazyModuleMethod(() => import('./fetchArticles'), 'default'),
  fetchVerstkaIOArticleLinks: lazyModuleMethod(
    () => import('./fetchVerstkaIOArticleLinks'),
    'default'
  ),
  publishArticle: lazyModuleMethod(() => import('./publishArticle'), 'default'),
  searchArticles: lazyModuleMethod(() => import('./searchArticles'), 'default'),
  createArticle: lazyModuleMethod(() => import('./createArticle'), 'default'),
  createArticleEfficientTitle: lazyModuleMethod(
    () => import('./createArticleEfficientTitle'),
    'default'
  ),
  createGoogleArticle: lazyModuleMethod(
    () => import('./createGoogleArticle'),
    'default'
  ),
  createWordArticle: lazyModuleMethod(
    () => import('./createWordArticle'),
    'default'
  ),
  deleteArticle: lazyModuleMethod(() => import('./deleteArticle'), 'default'),
  exportArticles: lazyModuleMethod(() => import('./exportArticles'), 'default'),
  exportWordArticle: lazyModuleMethod(
    () => import('./exportWordArticle'),
    'default'
  ),
  fetchArticleActiveUsers: lazyModuleMethod(
    () => import('./fetchArticleActiveUsers'),
    'default'
  ),
  fetchArticleEfficientTitles: lazyModuleMethod(
    () => import('./fetchArticleEfficientTitles'),
    'default'
  ),
  fetchArticlePushToday: lazyModuleMethod(
    () => import('./fetchArticlePushToday'),
    'default'
  ),
  fetchArticleMeta: lazyModuleMethod(
    () => import('./fetchArticleMeta'),
    'default'
  ),
  fetchArticleUrl: lazyModuleMethod(
    () => import('./fetchArticleUrl'),
    'default'
  ),
  fetchDeletedArticles: lazyModuleMethod(
    () => import('./fetchDeletedArticles'),
    'default'
  ),
  sendToKadam: lazyModuleMethod(() => import('./sendToKadam'), 'default'),
  syncProductionArticle: lazyModuleMethod(
    () => import('./syncProductionArticle'),
    'default'
  ),
  updateArticleEfficientTitle: lazyModuleMethod(
    () => import('./updateArticleEfficientTitle'),
    'default'
  ),
  fetchRecommendArticles: lazyModuleMethod(
    () => import('./fetchRecommendArticles'),
    'default'
  ),
  unPublishArticle: lazyModuleMethod(
    () => import('./unPublishArticle'),
    'default'
  ),
  updateArticle: lazyModuleMethod(() => import('./updateArticle'), 'default'),
  fetchRepublishPlan: lazyModuleMethod(
    () => import('./fetchRepublishPlan'),
    'default'
  ),
  fetchArticlesForComment: lazyModuleMethod(
    () => import('./fetchArticlesForComment'),
    'default'
  ),
  exportByAuthor: lazyModuleMethod(() => import('./exportByAuthor'), 'default'),
  fetchMostPopularArticles: lazyModuleMethod(
    () => import('./fetchMostPopularArticles'),
    'default'
  ),
  fetchReadNowArticles: lazyModuleMethod(
    () => import('./fetchReadNowArticles'),
    'default'
  ),
  restoreArticle: lazyModuleMethod(() => import('./restoreArticle'), 'default'),
}
